import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTermsAndConditions } from '../API/services/alkymersService';
import { editMe } from '../API/services/authService';
import { setUser } from '../redux/actions/authActions';
import { PARTNERS } from '../constants/enums';

const useTermsAndConditions = ({ platform = PARTNERS }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [showModal, setShowModal] = useState(false);
  const [termsAndConditionsLoading, setTermsAndConditionsLoading] = useState(false);
  const [termsAndConditionsData, setTermsAndConditionsData] = useState(null);
  const [modalContentLoading, setModalContentLoading] = useState(false);
  const [acceptedTermsAndConditions, setAcceptedTermsAndConditions] = useState(false);

  const showTermsAndConditionsModal = async () => {
    setShowModal(true);
    if (!termsAndConditionsData) {
      setTermsAndConditionsLoading(true);
      await getTermsAndConditions(platform).then((r) => {
        setTermsAndConditionsData(r);
        setTermsAndConditionsLoading(false);
      });
    }
  };

  const acceptTermsAndConditions = async (id) => {
    setModalContentLoading(true);
    editMe({
      id,
      toEdit: {
        termsAndConditionsAcceptance: new Date().toISOString(),
      },
    }).then((r) => {
      dispatch(setUser({ ...user, termsAndConditionsAcceptance: r.termsAndConditionsAcceptance }));
    });
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return {
    showModal,
    setShowModal,
    termsAndConditionsLoading,
    termsAndConditionsData,
    modalContentLoading,
    showTermsAndConditionsModal,
    acceptTermsAndConditions,
    closeModal,
    acceptedTermsAndConditions,
    setAcceptedTermsAndConditions,
  };
};

export default useTermsAndConditions;
